// extracted by mini-css-extract-plugin
module.exports = {"header":"infoRoute_header__29r5M","logo":"infoRoute_logo__1jaK3","description":"infoRoute_description__36BnQ"};